import React, { useEffect } from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { ThemeProvider } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';
import { getTheme } from './theme';
import CssBaseline from '@mui/material/CssBaseline';
import HomePage from './pages/HomePage';
import AboutPage from './pages/AboutPage';
//import AuthPage from './pages/AuthPage';
//import CodeOwnerPage from './pages/CodeOwnerPage';
import Header from './components/Header';
import Box from '@mui/material/Box';

function App() {
  const prefersDarkMode = useMediaQuery('(prefers-color-scheme: dark)');
  const theme = React.useMemo(
    () => getTheme(prefersDarkMode ? 'dark' : 'light'),
    [prefersDarkMode]
  );

  // Check for stored auth on app load
  useEffect(() => {
    const token = localStorage.getItem('authToken');
    const ownerData = localStorage.getItem('ownerData');
    
    if (token && ownerData) {
      // Validate token here if needed
      console.log('CodeOwner session restored:', {
        token: token.substring(0, 20) + '...',
        ownerData: JSON.parse(ownerData)
      });
    }
  }, []);

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <BrowserRouter>
        <Header />
        <Box sx={{ paddingTop: '0px' }}>
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/about" element={<AboutPage />} />
            <Route path="/login" element={<Navigate to="/" replace />} />
            {/* <Route path="/auth" element={<AuthPage />} /> */}
            {/* <Route path="/code-owner" element={<CodeOwnerPage />} /> */}
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </Box>
      </BrowserRouter>
    </ThemeProvider>
  );
}

export default App;
